import { render } from "./TodayHeartRate.vue?vue&type=template&id=5ae9e524&scoped=true&ts=true"
import script from "./TodayHeartRate.vue?vue&type=script&lang=ts"
export * from "./TodayHeartRate.vue?vue&type=script&lang=ts"

import "./TodayHeartRate.vue?vue&type=style&index=0&id=5ae9e524&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae9e524"]])

export default __exports__